import React from 'react';
import { storage, path } from '@commons';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, ...rest }) => {
    const user = storage.get(path.sessionUser);

    return (
        <Route {...rest} render={props => 
            <Component {...props} />
        } />
    );
};
